import { alpha } from '@material-ui/core/styles';

// ----------------------------------------------------------------------

export default function Input(theme) {
  return {
    MuiInputBase: {
      root: {
        '&.Mui-disabled': {
          '& svg': { color: theme.palette.text.disabled },
        },
      },
      input: {
        '&::placeholder': {
          opacity: 1,
          color: theme.palette.text.disabled,
        },
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottomColor: alpha(theme.palette.grey[500], 0.56),
        },
      },
    },
    MuiFilledInput: {
      root: {
        backgroundColor: alpha(theme.palette.grey[500], 0.12),
        '&:hover': {
          backgroundColor: alpha(theme.palette.grey[500], 0.16),
        },
        '&.Mui-focused': {
          backgroundColor: theme.palette.action.focus,
        },
        '&.Mui-disabled': {
          backgroundColor: theme.palette.action.disabledBackground,
        },
      },
      underline: {
        '&:before': {
          borderBottomColor: alpha(theme.palette.grey[500], 0.56),
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: alpha(theme.palette.grey[500], 0.32),
        },
        '&.Mui-disabled': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.action.disabledBackground,
          },
        },
      },
    },
  };
}
